import { AppThunk } from "../";

export const addFavourite =
  (id, type): AppThunk<void> =>
  (dispatch) => {
    if (!id) {
      throw Error("No id passed to addFavourite function");
    }

    // make sure type is always a valid value
    switch (type) {
      case "opp":
      case "org":
        break;
      default:
        type = "opp";
        break;
    }

    dispatch({
      type: type === "opp" ? "FAVOURITES:OPP:ADD" : "FAVOURITES:ORG:ADD",
      payload: {
        id,
      },
    });

    return fetch("/api/favourites", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        type,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }

        throw Error("Unhandled error");
      })
      .then(({ data, success, errorCode, errorMessage }) => {
        if (success) {
          return true;
        }

        throw Error("Recieved false for success from API");
      });
  };

export const removeFavourite =
  (id, type): AppThunk<void> =>
  (dispatch) => {
    if (!id) {
      throw Error("No id passed to addFavourite function");
    }

    // make sure type is always a valid value
    switch (type) {
      case "opp":
      case "org":
        break;
      default:
        type = "opp";
        break;
    }

    dispatch({
      type: type === "opp" ? "FAVOURITES:OPP:REMOVE" : "FAVOURITES:ORG:REMOVE",
      payload: {
        id,
      },
    });

    fetch("/api/favourites", {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        type,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .then(({ data, success, errorCode, errorMessage }) => {
        if (success) {
          return true;
        }
      });
  };

export const getFavourites = (): AppThunk<void> => (dispatch) => {
  dispatch({
    type: "FAVOURITES:FETCH:START",
  });
  fetch("/api/favourites/list")
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
    })
    .then(({ data, success, errorCode, errorMessage }) => {
      if (success) {
        dispatch({
          type: "FAVOURITES:FETCH:END",
          payload: {
            opportunities: data.favourites.opportunities.reduce((acc, cur) => {
              acc[cur.id] = cur.date;
              return acc;
            }, {}),
            organisations: data.favourites.organisations.reduce((acc, cur) => {
              acc[cur.id] = cur.date;
              return acc;
            }, {}),
          },
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: "FAVOURITES:FETCH:END",
        payload: {
          opportunities: {},
          organisations: {},
        },
      });
      console.log(err);
    });
};
